export default "__VITE_ASSET__e72f021b__"